<template>
	<div class="sidebar-settings-tbf">
		<div class="header">{{$t('navbar.settings')}}</div>
		<div class="main-menu">
			<div class="item-menu">
				<router-link :to="{name: 'settings-roles' }">
					<span class="text">{{$t('settings-navbar.roles')}}</span>
					<div class="arrow"><icon-arrow /></div>
				</router-link>
			</div>
			<div class="item-menu">
				<router-link :to="{name: 'settings-profile' }">
					<span class="text">{{$t('settings-navbar.profile')}}</span>
					<div class="arrow"><icon-arrow /></div>
				</router-link>
			</div>
			<div class="item-menu" v-if="$auth.user().is_admin">
				<router-link :to="{name: 'smart-planner'}">
					<span class="text">{{$t('settings-navbar.smart-planner')}}</span>
					<div class="arrow"><icon-arrow /></div>
				</router-link>
			</div>
			<div class="item-menu" v-if="$auth.user().is_entrepreneur && !$auth.user().free_account">
				<router-link :to="{name: 'settings-subscriptions'}">
					<span class="text">{{$t('settings-navbar.subscriptions')}}</span>
					<div class="arrow"><icon-arrow /></div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
    import IconArrow from '../Icons/Arrow.vue'

	export default {
		components: {
            IconArrow
		},
		data() {
			return {
				
			};
		},
		methods: {

		}
	};
</script>

<style lang="scss">
    @import "../../scss/templates/settings-template.scss";
</style>